/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "berth--sprite",
  "use": "berth--sprite-usage",
  "viewBox": "0 0 30 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 23\" id=\"berth--sprite\"><path d=\"M10.631 7.81c0 2.424-1.852 4.393-4.125 4.393-2.271 0-4.125-1.97-4.125-4.394 0-2.427 1.854-4.395 4.125-4.395 2.273 0 4.125 1.968 4.125 4.395Zm-1.314-.002c0-1.646-1.256-2.99-2.811-2.99-1.552 0-2.811 1.344-2.811 2.99 0 1.644 1.26 2.988 2.811 2.988 1.555 0 2.811-1.344 2.811-2.988Z\" fill=\"#232323\" stroke=\"#fff\" stroke-width=\".1\" /><path d=\"M11.492 12.977h.05V5.189c0-1.163.89-2.106 1.976-2.106h6.854c3.076 0 5.318 1.354 6.868 3.344 1.55 1.99 2.408 4.618 2.705 7.162v.013l.002.029.002.031v.012l.001.004v.002l-.001 5.045v.003l-.002.01.002 3.51c0 .39-.296.702-.657.702-.359 0-.657-.312-.657-.703V19.43H1.364v2.817c0 .391-.299.703-.657.703-.361 0-.657-.312-.657-.703V.753C.05.362.346.05.707.05c.358 0 .657.312.657.703v12.224h10.128Zm16.98-.002h.06l-.011-.058c-.216-1.205-.743-3.31-1.97-5.115-1.229-1.806-3.16-3.314-6.18-3.314h-6.853c-.369 0-.663.32-.663.7v7.787h15.617ZM1.364 17.974v.05h27.27v-3.643H1.365v3.593Z\" fill=\"#232323\" stroke=\"#fff\" stroke-width=\".1\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
